module.exports = __webpack_public_path__ + "img/HHemleklap.5427d517.jpg";